import { render, staticRenderFns } from "./StartInstructions.vue?vue&type=template&id=00ecacf4&scoped=true"
import script from "./StartInstructions.vue?vue&type=script&lang=js"
export * from "./StartInstructions.vue?vue&type=script&lang=js"
import style0 from "./StartInstructions.vue?vue&type=style&index=0&id=00ecacf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ecacf4",
  null
  
)

export default component.exports